var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.file)?_c('div',{staticClass:"vue-image-previewer"},[_c('img',{staticClass:"vue-image-previewer__image",attrs:{"src":_vm.file_,"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }